import { fetcher } from '@commenda/utils';

import { getFilingConductorAnalysisStartPath } from './filing-conductor-analysis-paths';
import {
  FilingConductorAnalysisMutationResult,
  FilingConductorAnalysisStartResponse,
  StartFilingConductorAnalysisParams,
} from './types';

export async function startFilingConductorAnalysis({
  corporationId,
  scope,
  analysisWindowStart,
  analysisWindowEnd,
}: StartFilingConductorAnalysisParams): Promise<
  FilingConductorAnalysisMutationResult<FilingConductorAnalysisStartResponse>
> {
  try {
    const body =
      scope.type === 'PERIOD'
        ? {
            fromDueDate: scope.fromDueDate,
            toDueDate: scope.toDueDate,
            ...(analysisWindowStart ? { analysisWindowStart } : {}),
            ...(analysisWindowEnd ? { analysisWindowEnd } : {}),
          }
        : {};

    const response = await fetcher(
      getFilingConductorAnalysisStartPath(corporationId, scope),
      { method: 'POST', body }
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to start analysis',
        status: response.status,
      };
    }
    return {
      success: true,
      data: json as FilingConductorAnalysisStartResponse,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to start analysis',
    };
  }
}
